import { ca } from '@cian/analytics';

interface ITrackDeleteNewbuildingFavorite {
  label: string;
  newbuildingId: number;
}

export function trackDeleteNewbuildingFavorite({ label, newbuildingId }: ITrackDeleteNewbuildingFavorite) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_compare',
    label,
    products: [{ id: newbuildingId, offerType: 'JK' }],
  });
}
